import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateChildFn,
    CanActivateFn,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import * as ClaimCategoryActions from '@app/modules/claim-categories/actions/claim-category-api.actions';
import { ClaimCategoryService } from '@app/modules/claim-categories/services/claim-category.service';
import { State } from '@app/reducers';
import { Store } from '@ngrx/store';
import { catchError, map, tap } from 'rxjs/operators';

export const canActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const claimCategoryService = inject(ClaimCategoryService);
	const router = inject(Router);
	const store = inject(Store<State>);

	return claimCategoryService.get(route.params['type'], route.params['value']).pipe(
		map((claimCategory) => ClaimCategoryActions.GetSuccess({ claimCategory: claimCategory })),
		tap((action: any) => store.dispatch(action)),
		map((claimCategory) => !!claimCategory),
		catchError(() => {
			return router.navigate(['/not-found']);
		})
	);
};

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
	canActivate(route, state);
